// extracted by mini-css-extract-plugin
module.exports = {"container":"f0","image":"f1","title":"f2","desc":"f3"};